import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const BrandIdentity = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "I start with strategy. Before touching a pixel, we get into your business: who you're talking to, what you believe, and why anyone should care. Brand workshops, competitor mapping, and positioning work come before mood boards — so when the visual direction arrives, it's rooted in something real, not just something pretty.",
    },
    {
      title: 'Delivery',
      description:
        "You'll receive a complete brand identity system: primary and secondary logo lockups, colour palette with usage guidance, typography system, iconography style, and a brand guidelines document your team can actually follow. Everything is delivered in formats ready for print, web, and everything in between.",
    },
    {
      title: 'Results',
      description:
        "A brand that opens doors. Clients report stronger first impressions, improved conversion from marketing materials, and — crucially — the confidence to show up consistently across every touchpoint. Because when your brand looks like it has its act together, people assume the rest of you does too.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="Brand Identity Services | Heretic Studio"
        description="Your brand is more than visuals—it's how people remember you. We build cohesive identities that communicate your values, stand out in the market, and stay consistent across every touchpoint."
      />
      <div className="studio-page service-page service-page--brand-identity">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">Brand Identity</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">Look the part. Mean it.</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  Brand identities that are distinctive, coherent, and built to last
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default BrandIdentity;
